module.exports = __webpack_public_path__ + "img/robot.de704c2f.svg";